import { ReactElement } from 'react';
import { useParams } from 'react-router-dom';

import { Widget } from '../Widget';
import { WidgetSkeleton } from '../Widget/WidgetSkeleton';
import { WidgetsEmpty } from '../WidgetsEmpty';
import { WidgetsError } from '../WidgetsError';
import { useWidgetsApi } from '../useWidgetsApi';

import styles from './styles.module.scss';

import { APP_LOCAL_SCHEME } from ':constants/app';

export function WidgetsGrid(): ReactElement {
  const { employeeNumber } = useParams();
  const { data, isLoading, isSuccess, error, refetch } =
    useWidgetsApi(employeeNumber);

  let items = data?.items;

  if (APP_LOCAL_SCHEME?.widgets) {
    items = [...APP_LOCAL_SCHEME.widgets, ...(items ?? [])];
  }

  if (error || (isSuccess && !items)) {
    return <WidgetsError refetch={refetch} />;
  }

  if (isSuccess && !items?.length) {
    return <WidgetsEmpty />;
  }

  return (
    <ul className={styles.grid}>
      {isLoading ? (
        <>
          <WidgetSkeleton />
          <WidgetSkeleton />
        </>
      ) : (
        <>{items?.map(el => <Widget {...el} key={el.id} />)}</>
      )}
    </ul>
  );
}
